/* unplugin-vue-components disabled */import script from "./alarmHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./alarmHistory.vue?vue&type=script&setup=true&lang=js"

import "./alarmHistory.vue?vue&type=style&index=0&id=dc4d3a76&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc4d3a76"]])

export default __exports__